// Translation: Model > Phone number verifier > Phone verification dialog (Russian)
export default Object.freeze({
	actions: {
		cancel: '',
		resend: '',
		send: ''
	},
	input: {
		placeholder: ''
	},
	title: ''
})
